import { EntityService } from '@/services/EntityService';

export class NotificationsService extends EntityService {
  static get entity() {
    return 'notifications';
  }
}
